/**
 * constants/propFirm.ts
 * Prop firm option constants for Account form selectors
 *
 * Provides UI-ready option arrays for prop firm name, asset class,
 * and account stage Select components.
 */

/**
 * Prop firm name options
 */
export const PROP_FIRM_OPTIONS = [
  { value: 'apex', label: 'Apex' },
  { value: 'topstep', label: 'TopStep' },
  { value: 'tradeify', label: 'Tradeify' },
  { value: 'myff', label: 'MYFF' },
  { value: 'earn2trade', label: 'Earn2Trade' },
  { value: 'fundednext', label: 'FundedNext' },
  { value: 'other', label: 'Other' },
] as const;

/**
 * Prop firm asset class options
 */
export const PROP_FIRM_ASSET_CLASS_OPTIONS = [
  { value: 'futures', label: 'Futures' },
  { value: 'forex-cfd', label: 'Forex & CFD' },
  { value: 'other', label: 'Other' },
] as const;

/**
 * Account stage options
 */
export const ACCOUNT_STAGE_OPTIONS = [
  { value: 'evaluation', label: 'Evaluation' },
  { value: 'funded-simulation', label: 'Funded (Simulated)' },
  { value: 'funded-live', label: 'Funded (Live)' },
] as const;
